module.exports = function(val) {
	return val.split('').reverse().join('');
};


// WEBPACK FOOTER //
// ./app/statamic/resources/js/filters/reverse.js